<div class="cd-page" *ngIf="!loading && company; else loadingTpl">

  <!-- Title row -->
  <div class="cd-title-row">
    <h1 class="cd-title-row__name">{{ company.name }}</h1>
    <span
      class="cd-status cd-status--{{ statusMeta(company.status).cssClass }}"
      *ngIf="company.status"
    >{{ statusMeta(company.status).label }}</span>
  </div>

  <!-- Main two-column layout -->
  <div class="cd-layout">

    <!-- Left: info cards -->
    <div class="cd-main">
      <section class="cd-card" *ngFor="let section of sections">
        <h2 class="cd-card__title">{{ section.title }}</h2>
        <div class="cd-grid">
          <div class="cd-field" *ngFor="let field of section.fields">
            <span class="cd-label">{{ field.label }}</span>
            <span class="cd-value">{{ field.value }}</span>
          </div>
        </div>
      </section>
    </div>

    <!-- Right: approval actions — hidden until the approval flow is wired up -->
    <aside class="cd-sidebar cd-sidebar--hidden">
      <section class="cd-card">
        <h2 class="cd-card__title">Approval</h2>
        <button
          class="cd-btn cd-btn--primary"
          type="button"
          (click)="approveCompany()"
        >Approve Company</button>
        <button
          class="cd-btn cd-btn--danger"
          type="button"
          (click)="returnCompany()"
        >Return</button>
      </section>
    </aside>

  </div>
</div>

<ng-template #loadingTpl>
  <div class="cd-skeleton">
    <!-- Title row skeleton -->
    <div class="cd-skeleton__title-row">
      <div class="cd-skeleton__bar cd-skeleton__bar--title"></div>
      <div class="cd-skeleton__bar cd-skeleton__bar--badge"></div>
    </div>

    <div class="cd-layout">
      <!-- Left column: info cards -->
      <div class="cd-main">
        <div class="cd-skeleton__card" *ngFor="let card of skeletonCards">
          <div class="cd-skeleton__bar cd-skeleton__bar--card-title"></div>
          <div class="cd-skeleton__grid">
            <div class="cd-skeleton__bar cd-skeleton__bar--field" *ngFor="let f of card.fields"></div>
          </div>
        </div>
      </div>

      <!-- Right column: sidebar cards -->
      <div class="cd-sidebar">
        <div class="cd-skeleton__card" *ngFor="let card of skeletonSidebarCards">
          <div class="cd-skeleton__bar cd-skeleton__bar--card-title"></div>
          <div class="cd-skeleton__grid">
            <div class="cd-skeleton__bar cd-skeleton__bar--field" *ngFor="let f of card.fields"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
